import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { X, Paperclip, Send } from "react-feather";
import { Oval } from "react-loader-spinner";
import { Socket, io } from "socket.io-client";
import {
  IAnexoComunicacao,
  IComunicacao,
  useComunicacao,
} from "../../../Hooks/comunicacoes";
import { useFuncionarioCartorio } from "../../../Hooks/funcionarioCartorio";
import { useFuncionarioPrefeitura } from "../../../Hooks/funcionarioPrefeitura";
import { useSocket } from "../../../Hooks/socketHelper";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import api from "../../../Services/apiComunicacao";
import theme from "../../../Styles/theme";
import {
  baseUrlApiNotoficacoes,
  // baseUrlApiNotoficacoes,
  baseUrlSocket,
  pathSocket,
} from "../../../Utils/baseUrl";
import { isRural } from "../../../Utils/isRural";
import { Alert } from "../../Error/Alert";
import { ModalLoader } from "../../ModalLoader";
import { AnexosComunicacaoModal } from "./AnexosComunicacaoModal";
import { CardMessage } from "./CardMessage";
import {
  Container,
  DivX,
  Footer,
  MessageContainer,
  HelperInputs,
  InputButton,
  MessageInput,
  PLoader,
  HandleMessageContainer,
  SpanMenssagens,
  AttachButton,
  SendButton,
} from "./styles";
import { useCartorio } from "../../../Hooks/cartorio";

interface Props {
  onClose(): void;
  imovel: IImovelFocus;
}

export function MessagesDiv({ onClose, imovel }: Props) {
  const {
    handleCloseComunicacao,
    getComunicacao,
    comunicacao,
    addComunicacao,
    acabou,
    addAnexoComunicacao,
  } = useComunicacao();
  const [anexoModal, setAnexoModal] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingPostMessage, setLoadingPostMessage] = useState(false);
  const [finalMessages, setFinalMessages] = useState(false);
  const [comunicacaoNaoIniciada, setComunicacaoNaoIniciada] = useState(true);

  const messagesEndRef = useRef<HTMLDivElement>(null);


  const { cartorioIsLogged, cartorio } = useCartorio();
  const {
    checarTokenFuncionario,
    funcionarioCartorioIsLogged,
    funcionarioCartorio,
  } = useFuncionarioCartorio();

  async function notificaNovaMenssagem() {
    try {
      if (funcionarioCartorioIsLogged || cartorioIsLogged) {
        await axios.post(
          `${baseUrlApiNotoficacoes}/prefeitura/notifica-nova-menssagem/${imovel.PREFEITURA_ID}`,
          { imovel_id: imovel.ID, isRural: isRural() }
        );
      } else if (funcionarioPrefeituraIsLogged) {
        await axios.post(
          `${baseUrlApiNotoficacoes}/cartorio/notifica-nova-menssagem/${imovel.CARTORIO_ID}`,
          { imovel_id: imovel.ID, isRural: isRural() }
        );
      }
    } catch (error) {
      console.log("NÃO FOI POSSÍVEL NOTIFICAR A MENSSAGEM!");
    }
  }

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView();
    }
  }, [comunicacao, open]);




  const {
    checarTokenFuncionarioPrefeitura,
    FuncionarioPrefeitura,
    funcionarioPrefeituraIsLogged,
  } = useFuncionarioPrefeitura();
  async function postMessage() {
    // window.alert(message)
    try {
      setLoadingPostMessage(true);
      if (message.trim().length == 0) {
        setError({
          message: "Não é possível enviar uma menssagem vazia!",
          title: "Menssagem vazia",
        });
        return;
      }

      if (message.trim().length > 5000) {
        setError({
          message:
            "Não é possível enviar uma menssagem contendo mais de 5000 caractéres!",
          title: "Menssagem grande demais!",
        });
        return;
      }

      // const { data } = await api.post<IComunicacao>(`/comunicacao`, {
      //   FUNCIONARIO_PREFEITURA_ID: funcionarioPrefeituraIsLogged
      //     ? FuncionarioPrefeitura.ID
      //     : null,
      //   FUNCIONARIO_CARTORIO_ID: funcionarioCartorioIsLogged
      //     ? funcionarioCartorio.ID
      //     : null,
      //   IMOVEL_ID: isRural() ? null : imovel.ID,
      //   IMOVEL_RURAL_ID: isRural() ? imovel.ID : null,
      //   MENSSAGEM: message.trim(),
      // });

      const { data } = await api.post<IComunicacao>(`/comunicacao`, {
        FUNCIONARIO_PREFEITURA_ID: funcionarioPrefeituraIsLogged
          ? FuncionarioPrefeitura.ID
          : null,
        FUNCIONARIO_CARTORIO_ID: funcionarioCartorioIsLogged
          ? funcionarioCartorio.ID
          : null,
        CARTORIO_ID: cartorioIsLogged ? cartorio.ID : null,
        IMOVEL_ID: isRural() ? null : imovel.ID,
        IMOVEL_RURAL_ID: isRural() ? imovel.ID : null,
        MENSSAGEM: message.trim(),
      });


      //if (data) {

      notificaNovaMenssagem();

      // }

      setMessage("");
    } catch (error) {
      setError({
        message: "Não foi possível enviar a menssagem!",
        title: "Erro ao enviar menssagem",
      });
    } finally {
      setLoadingPostMessage(false);
    }
  }

  async function handleGetComunicacao() {
    try {
      setLoading(true);
      await getComunicacao(imovel.ID, 1000000);
    } catch (error) {
      setError({
        message: "Erro ao carregar menssagens",
        title: "Não foi possível carregar as menssagens!",
      });
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (imovel.ID) {
      handleGetComunicacao();
    }
  }, [imovel]);

  useEffect(() => {
    if (comunicacao) {
      if (comunicacao.length > 0) {
        setComunicacaoNaoIniciada(false);
      } else {
        setComunicacaoNaoIniciada(true);
      }
    }
  }, [comunicacao]);

  function renderComunicacao() {
    if (comunicacao) {
      if (comunicacao.length > 0) {
        return comunicacao.map((item) => {
          if (item.ID) return <CardMessage message={item} />;
        });
      }
    }
  }

  useEffect(() => {
    // window.alert(JSON.stringify(comunicacao));
  }, [comunicacao]);

  const { socket, handleSetSocket } = useSocket();
  useEffect(() => {
    if (socket.active) socket.disconnect();
    const teste = io(baseUrlSocket, {
      path: pathSocket,
    });

    handleSetSocket(teste);


    // socket.on(`new_anexo`, (anexo:IAnexoComunicacao)=>{
    //   console.log("new_anexo")
    //   console.log(anexo)
    //   console.log(comunicacao)
    //   addAnexoComunicacao(anexo, comunicacao);
    // });
  }, [imovel.ID]);

  useEffect(() => {
    if (socket.active)
      socket.on(
        `new_comunicacao_imovel${isRural() ? "_rural" : ""}_id_${imovel.ID}`,
        (com: IComunicacao) => {
          if (com.MENSSAGEM != null || com.IDENTIFICADOR != null) {

            addComunicacao(com);
          }
        }
      );

    // window.alert(`new_comunicacao_imovel${isRural()?"_rural" : ""}_id_${imovel.ID}`);
  }, [socket]);

  useEffect(() => {
    // if(window.location.href.indexOf(`/imovel/${imovel.ID}`) == -1){
    //   if(socket)
    //   socket.close()
    // }
  }, [window.location.href]);

  useEffect(() => {
    setFinalMessages(!acabou);
  }, [acabou]);

  //  useEffect(() => {
  //     const TESTE = document.querySelector("#sentinela_comunicacao");
  //     const intersectionObserver = new IntersectionObserver((entries) => {
  //       if (entries.some((entry) => entry.isIntersecting)) {
  //         if (comunicacao)
  //           if (comunicacao.length > 0) {
  //             getComunicacao(imovel.ID, comunicacao[0].ID);
  //           }
  //       }
  //     });
  //     if (TESTE) {
  //       intersectionObserver.observe(TESTE);
  //       return () => intersectionObserver.disconnect();
  //     }
  //  }, [document.querySelector("#sentinela_comunicacao")]);

  useEffect(() => {
    handleCloseComunicacao();
  }, [imovel.ID]);

  useEffect(() => { }, [comunicacao]);
  return (
    <Container style={{ marginBottom: "10vh" }}>
      <DivX>
        <X
          color={theme.colors.dark}
          size={"max(1.4vw, 14px)"}
          style={{ cursor: "pointer" }}
          onClick={onClose}
        />
      </DivX>
      {!imovel.ENVIADO && (
        <span>
          {
            "Enquanto não enviar o imovel para avaliação, suas mensagens não serão visualizadas pela prefeitura!"
          }
        </span>
      )}
      <HandleMessageContainer>
        <MessageContainer id={"container_messages"} style={{
          display: "flex",
          // flexDirection: "column-reverse",
          overflowY: "auto",
          height: "100%", // Ajuste conforme o tamanho do seu layout
        }}>
          <PLoader id="sentinela_comunicacao">
            <Oval
              color={theme.colors.primary}
              width={"max(2vw, 14px)"}
              height={"max(1.8vw, 14px)"}
              secondaryColor={theme.colors.secondary}
              visible={loading}
            />
          </PLoader>
          {comunicacaoNaoIniciada ? (
            <SpanMenssagens>Nenhuma Mensagem foi enviada ainda!</SpanMenssagens>
          ) : (
            ""
          )}
          {renderComunicacao()}
          <div ref={messagesEndRef} />

        </MessageContainer>
      </HandleMessageContainer>

      {(funcionarioCartorioIsLogged || funcionarioPrefeituraIsLogged || cartorioIsLogged) && (imovel.ENVIADO) ? (
        <Footer>
          <AttachButton onClick={() => setAnexoModal(true)}>
            <Paperclip size={20} />
          </AttachButton>

          <MessageInput
            onChange={(ev) => setMessage(ev.target.value)}
            value={message}
          ></MessageInput>
          {loadingPostMessage ? (
            <Oval
              width={"max(1vw, 8px)"}
              height={"max(1vw, 8px)"}
              color={theme.colors.primary}
              secondaryColor={theme.colors.dark}
            />
          ) : (
            <SendButton onClick={postMessage} disabled={loadingPostMessage}>
              <Send size={20} />
            </SendButton>

          )}
        </Footer>
      ) : (
        ""
      )}

      <Alert
        message={error.message}
        title={error.title}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
      <AnexosComunicacaoModal
        open={anexoModal}
        onClose={() => setAnexoModal(false)}
        imovel_id={imovel.ID}
      />

      {/* <ModalLoader loading={loading} /> */}
    </Container>
  );
}
